import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  deviceMapTypes,
  fetchDeviceMapSuccess,
  fetchDeviceMapFailure,
  handlePlayPauseSuccess,
  handlePlayPauseFailure,
} from "../actions/deviceMap";
import { fetchassetmapEndPoint } from "../../configuration";
import { dateFormatWithAt } from "../../global/utility/dateFormat";

function* fetchDeviceMapSaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceMap.currentId,
        startDateTime: state.deviceMap.startDateTime,
        endDateTime: state.deviceMap.endDateTime,
      };
    });

    const deviceMapResponse = yield call(
      fetchDeviceMapAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );

    const deviceMapData = deviceMapResponse?.data?.map((item, index) => {
      let color = "#FF8027";
      if (index === 0) color = "#63D48E";
      if (index === deviceMapResponse.length - 1) color = "#0089EC";
      return {
        geometry: {
          type: "Point",
          coordinates: [
            item?.fields?.location?.longitude,
            item?.fields?.location?.latitude,
          ],
        },
        properties: {
          id: index + 1,
          color: color,
          borderColor: "#ffffff",
          lastupdated: item?.lastupdated ? dateFormatWithAt(item?.lastupdated) : "N/A",
          positiontype: item?.fields?.location?.type,
          latVal: item?.fields?.location?.latitude,
          lonVal: item?.fields?.location?.longitude,
        },
      };
    });

    yield put(fetchDeviceMapSuccess(deviceMapData));
  } catch (error) {
    console.log("error", error);
    yield put(fetchDeviceMapFailure(error.message));
  }
}

async function fetchDeviceMapAPI(deviceId, startDateTime, endDateTime) {
  let startDateTimeISO = null;
  let endDateTimeISO = null;
  if (startDateTime && endDateTime) {
    startDateTimeISO = new Date(startDateTime);
    endDateTimeISO = new Date(endDateTime);
  }else {
    throw new Error("start Date and Time or end Date and Time is missing");
  }

  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'location' AND createdon between('${startDateTimeISO.toISOString()}','${endDateTimeISO.toISOString()}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* handlePausePlaySaga(action) {
  const isPlaying = action.payload;
  try {
    const options = yield select((state) => {
      return {
        currentIndex: state.deviceMap.currentIndex,
        mapData: state.deviceMap.data,
      };
    });

    yield put(
      handlePlayPauseSuccess({
        isPlaying,
        currentIndex: isPlaying
          ? options.currentIndex + 1
          : options.currentIndex,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(handlePlayPauseFailure(error.message));
  }
}

export function* DeviceMapSaga() {
  yield takeLatest(deviceMapTypes.FETCH_DEVICE_MAP_REQUEST, fetchDeviceMapSaga);
}

export function* HandlePausePlaySaga() {
  yield takeLatest(
    deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_REQUEST,
    handlePausePlaySaga
  );
}
